import React from "react";
import "./cardPodcasts.scss";
import Button from "../../button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const CardPodcasts = ({title, url, btnTitle}) => {
  return (
    <article className="card-podcasts">
      <div className="card-podcasts__content">
        <h3>
          {title}
        </h3>
        <div className="btn-wrap">
          <Button
            to={url}
            className="btn-primary has-icon-right"
            external={true}
          >
            {btnTitle}
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        </div>
      </div>
    </article>
  );
};

export default CardPodcasts;
